"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.fetchAccountsForBlockchainServices = exports.waitForTransaction = exports.hasSwap = exports.hasLedger = exports.hasExplorerService = exports.hasNft = exports.isCalculableFee = exports.isClaimable = exports.hasNameService = void 0;
function hasNameService(service) {
    return 'resolveNameServiceDomain' in service && 'validateNameServiceDomainFormat' in service;
}
exports.hasNameService = hasNameService;
function isClaimable(service) {
    return 'claim' in service && 'claimToken' in service && 'getUnclaimed' in service.blockchainDataService;
}
exports.isClaimable = isClaimable;
function isCalculableFee(service) {
    return 'calculateTransferFee' in service;
}
exports.isCalculableFee = isCalculableFee;
function hasNft(service) {
    return 'nftDataService' in service;
}
exports.hasNft = hasNft;
function hasExplorerService(service) {
    return 'explorerService' in service;
}
exports.hasExplorerService = hasExplorerService;
function hasLedger(service) {
    return 'ledgerService' in service;
}
exports.hasLedger = hasLedger;
function hasSwap(service) {
    return 'createSwapService' in service;
}
exports.hasSwap = hasSwap;
function wait(ms) {
    return new Promise(resolve => setTimeout(resolve, ms));
}
function waitForTransaction(service, txId) {
    return __awaiter(this, void 0, void 0, function* () {
        const maxAttempts = 30;
        const waitMs = service.blockchainDataService.maxTimeToConfirmTransactionInMs / maxAttempts;
        let attempts = 1;
        do {
            try {
                yield service.blockchainDataService.getTransaction(txId);
                return true;
            }
            catch (_a) {
                // Empty block
            }
            attempts++;
            yield wait(waitMs);
        } while (attempts < maxAttempts);
        return false;
    });
}
exports.waitForTransaction = waitForTransaction;
function fetchAccountsForBlockchainServices(blockchainServices, getAccountCallback) {
    return __awaiter(this, void 0, void 0, function* () {
        const accountsByBlockchainService = new Map();
        const promises = blockchainServices.map((service) => __awaiter(this, void 0, void 0, function* () {
            let index = 0;
            const accounts = [];
            let shouldBreak = false;
            while (!shouldBreak) {
                const generatedAccount = yield getAccountCallback(service, index);
                if (index !== 0) {
                    try {
                        const { transactions } = yield service.blockchainDataService.getTransactionsByAddress({
                            address: generatedAccount.address,
                        });
                        if (!transactions || transactions.length <= 0)
                            shouldBreak = true;
                    }
                    catch (_a) {
                        shouldBreak = true;
                    }
                }
                accounts.push(generatedAccount);
                index++;
            }
            accountsByBlockchainService.set(service.blockchainName, accounts);
        }));
        yield Promise.all(promises);
        return accountsByBlockchainService;
    });
}
exports.fetchAccountsForBlockchainServices = fetchAccountsForBlockchainServices;
